import { Dropdown, EllipsisDropdownItem, IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

export type SortOptionId = "recently_viewed" | "date_created";

interface TrackSectionSortDropdownProps {
    selectedSortId: SortOptionId;
    onSortChange: (sortId: SortOptionId) => void;
}

export const TrackSectionSortDropdown = ({ selectedSortId, onSortChange }: TrackSectionSortDropdownProps) => {
    const t = useTranslation();

    const handleSortDropdownItemClick = ({ id }: { id: SortOptionId }) => {
        onSortChange(id);
    };

    return (
        <Flex>
            <Dropdown
                dropdownPopupPlacement="bottom-right"
                onClick={handleSortDropdownItemClick}
            >
                <IconButton
                    type="flatDark"
                    iconName="chev-down"
                    placement="right"
                >
                    {selectedSortId === "recently_viewed"
                        ? t("demand_analysis.home.library.sort.recently_viewed")
                        : t("demand_analysis.home.library.sort.date_created")}
                </IconButton>
                <EllipsisDropdownItem
                    id="recently_viewed"
                    selected={selectedSortId === "recently_viewed"}
                >
                    {t("demand_analysis.home.library.sort.recently_viewed")}
                </EllipsisDropdownItem>
                <EllipsisDropdownItem
                    id="date_created"
                    selected={selectedSortId === "date_created"}
                >
                    {t("demand_analysis.home.library.sort.date_created")}
                </EllipsisDropdownItem>
            </Dropdown>
        </Flex>
    );
};
